module.exports = "/_next/static/images/DeliveryDestinations@2x-e3425e3f64c4493b305ff1e699516b0a.png";